export default __webpack_public_path__ + "static/media/twitter_copy.89498832.png";